
import React, { Fragment } from 'react';
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import Bg from '../../images/bg/page_bg01.jpg'
import CtaSection from '../../components/CtaSection/CtaSection';
import "./steps.css";


const datasafty = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  }
  return (
    <Fragment>
      <div className='body_wrap sco_agency mb-5 '>
        <Header />
        <section
          className="page-title pt-120 md:pt-30 pos-rel bg_img"
          style={{ backgroundImage: `url(${Bg})` }}
        >
          <div className="container ">
            <div className="page-title-wrap pt-3 pb-5">
              <div className="row mt-none-30 align-items-end">
                <div className="col-lg-12 text-center">
                  <div className="page-title-box">
                    <h2 className="title"> Delete Your Account</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="bg-light mb130">
          <div className="container p-5 mt-1" style={{ background: "#fff", borderRadius: "20px" }} bis_skin_checked={1} >
            <div className="row justify-content-center" bis_skin_checked={1}>
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center" bis_skin_checked={1}>
                <div className=" px-0 mt-4 mb-4" bis_skin_checked={1}>
                  <h3 id="heading"></h3>
                  <p className="fs-5 mt-2">If you have an account with Tigris Pay and wish to delete it, you may submit a deletion request by following the steps below. <br /> Once submitted, our support team will get in contact with you to assist further. </p>
                </div>
              </div>
            </div>
            <div className="row justify-content-center" bis_skin_checked={1}>
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center" bis_skin_checked={1}>
                <div id="msform" bis_skin_checked={1}>
                  <div className="form-card" style={{ border: "none" }} bis_skin_checked={1}>
                    <div className="row text-center justify-content-center" bis_skin_checked={1}>
                      <h3 className="mb-2">Temporary Account Deletion</h3>
                      <p className="mb-5">
                        Please follow the below steps to delete your account on a temporary basis.
                      </p>
                    </div>
                    <div className="row justify-content-center" bis_skin_checked={1}>
                      <div className="col-12 col-md-6 col-lg-6" bis_skin_checked={1}>
                        <div className="card cardcss" style={{ border: "none" }} bis_skin_checked={1}>
                          <img className="card-img-top" src="images/data-safety/4.png" alt="Data Safety" />
                          <div className="card-body" bis_skin_checked={1}>
                            <p className="card-text">
                              <strong>Step 1:</strong> Tap on Profile and scroll down to see Delete Account option.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-lg-6" bis_skin_checked={1}>
                        <div className="card cardcss" style={{ border: "none" }} bis_skin_checked={1}>
                          <img className="card-img-top" src="images/data-safety/2.png" alt="Data Safety" />
                          <div className="card-body" bis_skin_checked={1}>
                            <p className="card-text mb-4">
                              <strong>Step 2:</strong> Tap on Delete Account (displayed in red). A confirmation pop-up with Yes or Cancel will appear.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-lg-6" bis_skin_checked={1}>
                        <div className="card cardcss" style={{ border: "none" }} bis_skin_checked={1}>
                          <img className="card-img-top" src="images/data-safety/1.png" alt="Data Safety" />
                          <div className="card-body" bis_skin_checked={1}>
                            <p className="card-text">
                              <strong>Step 3:</strong> Tap Yes to submit your request. Our support team will get in contact with you shortly.
                            </p>
                          </div>
                        </div>
                      </div>
                      {/*<div class="col-12 col-md-6 col-lg-6">
										<div class="card cardcss">
											<img class="card-img-top" src="images/data-safety/4.png" alt="Data Safety">
											<div class="card-body">
												<p class="card-text mb-4">
													<strong>Step 4:</strong> Your request for account
													deletion will be submitted. Our team will reach out to you shortly.
												</p>
											</div>
										</div>
									</div>*/}
                    </div>
                    <hr />
                    <div className="row text-center justify-content-center" bis_skin_checked={1}>
                      <h3 className="mb-2 mt-3">Permanent Account Deletion</h3>
                      <p className="mb-5">
                        Please follow the below steps to delete your account permanently.
                      </p>
                    </div>
                    <div className="row justify-content-center" bis_skin_checked={1}>
                      <div className="col-12 col-md-6 col-lg-6" bis_skin_checked={1}>
                        <div className="card cardcss" style={{ border: "none" }} bis_skin_checked={1}>
                          <img className="card-img-top" src="images/data-safety/4.png" alt="Data Safety?" />
                          <div className="card-body" bis_skin_checked={1}>
                            <p className="card-text">
                              <strong>Step 1:</strong> Tap on Profile and scroll down to see Delete Account option.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-lg-6" bis_skin_checked={1}>
                        <div className="card cardcss" style={{ border: "none" }} bis_skin_checked={1}>
                          <img className="card-img-top" src="images/data-safety/2.png" alt="Data Safety?" />
                          <div className="card-body" bis_skin_checked={1}>
                            <p className="card-text">
                              <strong>Step 2:</strong> Tap on Delete Account (displayed in red). A pop-up will appear with the options Yes, Cancel, and No, delete my account permanently.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-lg-6" bis_skin_checked={1}>
                        <div className="card cardcss" style={{ border: "none" }} bis_skin_checked={1}>
                          <img className="card-img-top" src="images/data-safety/2.png" alt="Data Safety?" />
                          <div className="card-body" bis_skin_checked={1}>
                            <p className="card-text mb-4">
                              <strong>Step 3:</strong> Select No, delete my account permanently option (displayed in red). A final confirmation pop-up will appear—tap OK to proceed your request.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-lg-6" bis_skin_checked={1}>
                        <div className="card cardcss" style={{ border: "none" }} bis_skin_checked={1}>
                          <img className="card-img-top" src="images/data-safety/3.png" alt="Data Safety?" />
                          <div className="card-body" bis_skin_checked={1}>
                            <p className="card-text">
                              <strong>Step 4:</strong> Your account deletion request will be submitted, and our support team will contact you in accordance with UK data protection regulations.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row" bis_skin_checked={1}>
                      <div className="col-md-12 text-left" bis_skin_checked={1} style={{ textAlign: 'left' }}>
                        <p>
                          If you have completed your registration with Tigris Pay and have
                          processed your
                          transaction, you can also send us a request to delete your account.
                        </p>
                        <p>
                          But as per the Regulation 40 of The MLR 2017, we are liable:
                        </p>
                        <ul className="disc" >
                          <li style={{ marginLeft: 15, listStyle: "inside" }}>
                            To store your documents and information we have collected from you as a
                            part of the
                            customer due diligence (CDD) process.
                          </li>
                          <li style={{ marginLeft: 15, listStyle: "inside" }}>
                            To store any supporting records including original documents or copies you
                            have provided to
                            us as a part of CDD.
                          </li>
                        </ul>
                        <p>
                          We will store your data for 5 years beginning from when your transactions have
                          been
                          completed for which you have provided us your data to process the transaction.
                        </p>
                      </div>
                    </div>

                    <div className="col-md-12 text-left" bis_skin_checked={1} style={{ textAlign: 'left' }}>
                      <h3 className="mb-3 mt-5">We will not delete your account and data stored with us in the below</h3>
                      <p>
                        Please follow the below steps to delete your account permanently.
                      </p>
                      <p>
                        The period of 5 years will not be applicable in the following cases.
                      </p>
                      <p>
                        As per Regulation 40 (5), we will store your data if,
                      </p>
                      <ol className="decimal-list">
                        <li style={{ listStyle: "inside" }}>
                          We are liable to do so by or under any enactment,
                        </li>
                        <li style={{ listStyle: "inside" }}>
                          For any court proceedings;
                        </li>
                        <li style={{ listStyle: "inside" }}>
                          You have given consent to retain your data provided to us; or
                        </li>
                        <li style={{ listStyle: "inside" }}>
                          If Tigris Pay has reasons to believe that your data records need to
                          be maintained
                          with us for legal proceedings.
                        </li>
                      </ol>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

      </div>
      <CtaSection />
      <Footer />
      <Scrollbar />
    </Fragment>
  )
};
export default datasafty;